<template>
  <div class="files-upload">
    <input 
      type="file" 
      id="uFile" 
      name="uFile" 
      style="display: none;" 
      @change="handleInputUpload($event)" 
    />
    <div style="display: flex;justify-content: center;" v-if="!fileList||fileList&&!fileList.length||(fileList.length<limitLenth)">
      <div class="upload-button" @click="handleSelectFile">
        <van-icon name="add-o" class="add-o" size="18px" />上传附件
      </div>
    </div>
    <div class="file-list" v-if="fileList.length">
      <div class="file-item" v-for="(item,index) in fileList" :key="item.newFileName">
        <div style="display: flex;align-items: center;">
          <van-image
            v-if="handleFileIconOption(item.name).iconName === 'image-icon'"
            :width="handleFileIconOption(item.name).width"
            :height="handleFileIconOption(item.name).height"
            :src="item.url"
            style="margin-right: 20px;flex-shrink: 0;"
          >
            <template slot="loading">
              <van-image
                :width="handleFileIconOption(item.name).width"
                :height="handleFileIconOption(item.name).height"
                :src="require(`@/assets/image/filesIcon/${handleFileIconOption(item.name).iconName}.png`)"
              />
            </template>
            <template slot="error">
              <van-image
                :width="handleFileIconOption(item.name).width"
                :height="handleFileIconOption(item.name).height"
                :src="require(`@/assets/image/filesIcon/${handleFileIconOption(item.name).iconName}.png`)"
              />
            </template>
          </van-image>
          <van-image
            v-else
            :width="handleFileIconOption(item.name).width"
            :height="handleFileIconOption(item.name).height"
            :src="require(`@/assets/image/filesIcon/${handleFileIconOption(item.name).iconName}.png`)"
            style="margin-right: 20px;flex-shrink: 0;"
          />
          <div style="flex: 1;overflow: hidden;">
            <div style="display: flex;align-items: center;overflow: hidden;">
              <div class="file-name">{{ item.name.slice(0,item.name.lastIndexOf(".")) }}</div>
              <div class="file-name-suffix">{{ `.${item.type}` }}</div>
            </div>
            <div class="file-size">{{ filesizeFormat(item.size) }}</div>
          </div>
        </div>
        <div style="display: flex;align-items: center;justify-content: space-between;">
          <div class="file-upload-time">{{ item.createTime || "" }}</div>
          <div class="file-delete" @click="handleDelete(item,index)">
            <van-icon name="delete-o" size="11px" style="font-weight: bold;margin-right: 4px;line-height: 24px;" />删除
          </div>
        </div>
        <!-- <div style="display: flex;justify-content: space-between;align-items: center;">
          <div class="file-name">{{ item.name }}</div>
          <div class="file-delete" @click="handleDelete(item,index)">删除</div>
        </div>
        <div class="file-size">{{ item.size }}</div> -->
      </div>
    </div>
    <div class="footer">
      <div class="footer-button button-plain" @click="handleCancel">取消</div>
      <div class="footer-button" @click="handleSubmit">确定</div>
    </div>
  </div>
</template>

<script>
import { Uploader , Icon , Image as VanImage } from 'vant';
import { upload } from "@/api/dispatchImportAndExport/filesUpload/index.js";
import { parseTime } from "@/utils/ruoyi.js";
export default {
  components:{
    [Uploader.name]:Uploader,
    [Icon.name]:Icon,
    [VanImage.name]:VanImage,
  },
  data(){
    return {
      fileList:[],
      // 前端可回显文件格式
      fileSuffixList:[
        { iconName: "word-icon" , suffixList:["doc","docx"] , width: "36" , height: "40" },
        { iconName: "excel-icon" , suffixList:["xls","xlsx"] , width: "36" , height: "40" },  
        { iconName: "ppt-icon" , suffixList:["ppt","pptx"] , width: "36" , height: "40"},
        { iconName: "pdf-icon" , suffixList:["pdf"] , width: "39" , height: "40" },
        { iconName: "image-icon" , suffixList:["bmp","gif","ico","jpg","png","webp","heic","raw"] , width: "36" , height: "36" },
        { iconName: "video-icon" , suffixList:["mp4","flv","m3u8","rtmp","hls","rtsp","mov"] , width: "36" , height: "36" },
        { iconName: "audio-icon" , suffixList:["mp3"] , width:"33" , height: "40" },
        // { iconName: "unknown-icon" , suffixList:[] , width},
      ],
      // 后端限制文件格式
      backendSuffix:[
        // 图片
        "bmp", "gif", "jpg", "jpeg", "png", "raw",
        // Word Excel powerpoint
        "doc", "docx", "xls", "xlsx", "ppt", "pptx", "html", "htm", "txt", 
        // 压缩文件
        "rar", "zip", "gz", "bz2", 
        // 视频格式
        "mp4", "avi", "rmvb", "mov",
        // pdf
        "pdf"
      ],
      backendSuffixUpperCase:[],
      limitLenth:6, // 默认最多上传6张
    }
  },
  created(){
    // 兼容大写文件后缀
    this.fileSuffixList = this.fileSuffixList.map(fileItem=>({ ...fileItem , suffixList: this.handleToLocaleUpperCase(fileItem.suffixList) }));
    this.backendSuffixUpperCase = this.backendSuffix.map(item=>item.toLocaleUpperCase());
  },
  mounted(){
    let query = this.$route.query;
    this.limitLenth = query&&query.limitLenth?query.limitLenth:6
  },
  methods:{
    handleToLocaleUpperCase(list){
      let newList = [];
      list.map(item => {
        newList.push(item);
        newList.push(item.toLocaleUpperCase());
      });
      return newList;
    },
    handleCancel(){
      window.uni.navigateBack({ delta: 1 });
    },
    handleSubmit(){
      let query = this.$route.query;
      window.uni.postMessage({ data: {fileList:this.fileList,...query} });
      window.uni.navigateBack({ delta: 1 });
    },
    handleDelete(item,index){
      this.$dialog.confirm({
        message: `确定要删除"${item.name}"吗？`,
        allowHtml:false,
        confirmButtonColor:'#EC892E'
      }).then(()=>{
        this.fileList.splice(index,1);
        // window.uni.postMessage({ data: this.fileList });
      })
    },
    handleSelectFile(){
      document.querySelector("#uFile").click();
    },
    handleInputUpload(e){
      this.$loading.open();

      var files = document.getElementById('uFile').files;
      if(!files||files&&!files.length) return this.$loading.close()
      let [fileName, fileSize, fileType, lastModified] = [files[0].name, files[0].size, files[0].type, files[0].lastModified];

      let file = e.target.files[0];
      let fileSuffixIndex = file.name.lastIndexOf(".");
      let fileSuffix = file.name.slice(fileSuffixIndex+1);
      if(!this.backendSuffix.concat(this.backendSuffixUpperCase).includes(fileSuffix)) {
        this.$dialog.alert({
          message: `请上传[${this.backendSuffix}]格式文件`,
          allowHtml:false,
          confirmButtonColor:'#EC892E'
        });
        return this.$loading.close();
      }else if(file.size > 1024 * 1024 * 50) {
        this.$dialog.alert({
          message: `请上传小于50MB大小的文件`,
          allowHtml:false,
          confirmButtonColor:'#EC892E'
        });
        return this.$loading.close();
      }
      let param = new FormData()       // 创建form对象     
      param.append('file', file)       // 通过append向form对象添加数据
        upload(param)
        .then(res => {
          if(res.code !== 200) return this.$toast({message: res.msg ,icon:"fail"});
          this.fileList.push({
            ...res.data,
            size: fileSize,
            type: res.data.name.slice(res.data.name.lastIndexOf(".")+1),
            createTime: parseTime(+new Date(),"{y}-{m}-{d}")
          });
          document.getElementById('uFile').value = '';
        }).catch(err => {
          console.log("请求失败",JSON.stringify(err));
        }).finally(() => {
          this.$loading.close();
        })
    },
    filesizeFormat(size) {//把字节转换成正常文件大小
      if (!size) return "";
      var num = 1024.00; //byte
      if (size < num)
          return size + "B";
      if (size < Math.pow(num, 2))
          return (size / num).toFixed(2) + "KB"; //kb
      if (size < Math.pow(num, 3))
          return (size / Math.pow(num, 2)).toFixed(2) + "MB"; //M
      if (size < Math.pow(num, 4))
          return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
      return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
    },
    handleFileIconOption(fileName){
      let suffixIndex = fileName.lastIndexOf(".");
      let suffix = fileName.slice(suffixIndex+1);
      let suffixActive = this.fileSuffixList.find(item=>item.suffixList.includes(suffix));
      return suffixActive ? suffixActive : { iconName: "unknown-icon" , suffixList:[] , width: "36" , height: "40"};
      // return require(`@/assets/image/filesIcon/${suffixActive ? suffixActive.iconName : "unknown-icon"}.png`);
      // return require("@/assets/image/filesIcon/audio-icon.png")
    }
  }
}
</script>

<style scoped lang="scss">
  .files-upload {
    padding: 0 12px 100px;
    .upload-button {
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #EC892E;
      font-size: 14px;
      line-height: 18px;
      .add-o {
        margin-right: 8px;
        color: #EC892E;
        font-weight: bold;
      }
    }
    .file-list {
      padding: 8px 12px;
      margin-bottom: 20px;
      .file-item + .file-item {
        margin-top: 8px;
      }
      .file-item {
        border: 1px solid #EFEFEF;
        padding: 18px 16px 16px 16px;
        overflow: hidden;
        background-color: #FFF;
        .file-name {
          font-size: 16px;
          line-height: 24px;
          color: #333;
          word-break: break-all;
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .file-name-suffix {
          flex-shrink: 0;
          font-size: 16px;
          line-height: 24px;
          color: #333;
        }
        .file-delete {
          font-size: 12px;
          color: #DC3C33;
          line-height: 24px;
          flex-shrink: 0;
          margin-left: 16px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
        }
        .file-size {
          font-size: 12px;
          color: #A6B6C6;
          line-height: 20px;
        }
        .file-upload-time {
          font-size: 12px;
          line-height: 22px;
          color: #A6B6C6;
        }
      }
    }
    .footer {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      padding: 16px 32px 42px 32px;
      background-color: #FFF;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .footer-button {
        min-width: 122px;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFF;
        background-color: #EC892E;
        margin-bottom: 16px;
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid #EC892E;
        &:active {
          background-color: #f29100;
        }
      }
      .button-plain {
        background-color: #FFF;
        color: #EC892E;
        &:active {
          background-color: #EC892E;
          color: #FFF;
        }
      }
    }
  }
</style>